
export const tooltipStyles = {
  content: {
    backgroundColor: 'black',
    textAlign: 'center'
  },
  tooltip: {
    backgroundColor: 'black',
    opacity: '.96',
    borderRadius: '4px',
    textAlign: 'center',
    zIndex: '5',
    fontSize: '12px'
  },
  wrapper: {
    width: '100%',
    zIndex: '5'
  },
  arrow: {
    borderTop: '5px solid black'
  }
};
